module.exports = __webpack_public_path__ + "img/icon-market-camel.50e2e912.png";